import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.orangish,
  arrowHoverBgColor: colors.burntOrange,
  arrowForeColor: colors.white,
  arrowPrevMarginRight: '4px',
  arrowNextMarginLeft: '4px',
  highlightColor: colors.darkNight,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.orangish,
  paginationBorderColor: colors.orangish,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.orangish,
  heroPaginationInactiveColorVariationC: colors.orangish,
  heroPaginationActiveColor: colors.orangish,
  heroPaginationBorderColor: colors.burntOrange,
  bgColor: colors.white,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;